





























































































import mixins from 'vue-typed-mixins'
import { mapGetters } from 'vuex'
import { $, sleep } from '@/utils/helpers'
import ChatForm from '@/components/ChatForm.vue'
import UserActionMixin from '@/mixins/UserActionMixin'
import Queue from '@/utils/Queue'
import Call from '@/api/call'

enum CallEndReason {
  Normal = 1, // 通常終了
  Reject = 2, // 応答拒否
  DisconnectMakeCalling = 3, // 発信中に発信側が切断
  NotAnswer = 4, // 一定時間応答しなかった
  NotMakeCall = 5, // 発信から一定時間たっても通話が成立しなかった
  IncomingCallEnd = 6, // 着信終了
  TimeOver = 7, // 通話可能時間経過
  System = 8, // システムからの終了通知
  AppBackground = 9, // アプリがバックグラウンドになった
  NetworkError = 10, // ネットワークエラー
  OpenTokSessionError = 11, // OpenTok Session Error
  OpenTokStreamError = 12, // OpenTok Stream Error
  Abnormal = 99 // 異常終了
}

const CALL_WAIT_TIME = 60000
const CALL_ANSWER_WAIT_TIME = 20000
const TALKING_REPORT_SEC = 30

export default mixins(UserActionMixin).extend({
  name: 'Call',
  components: {
    ChatForm
  },
  data() {
    return {
      name: this.$route.params.name,
      profile_image_url: this.$route.params.profile_image_url,
      disabledAnswerButton: false,
      disabledEndCallButton: false,
      disabledCameraButton: false,
      isEndCalling: false,
      isTalking: false,
      session: null,
      subscriber: null,
      publisher: null,
      media: null,
      forceStopTimer: null,
      routerBackTimer: null,
      streamDestroyedTimer: null,
      endCallIntervalTimer: null,
      countupCallTimer: null,
      canPhoneCallMSec: 0,
      calledSnackBaers: {
        10: false,
        30: false,
        60: false
      },
      startTime: null,
      elapsedTime: 0,
      lastTalkingReportTime: 0,
      minutes: '00',
      seconds: '00',
      loadingTimer: null,
      vibrationTimer: null,
      callAnswerWaitTimer: null,
      isPlayingAudio: false,
      isConnectedOpenTokSession: false,
      isLoading: false,
      isTimeOver: false,
      cameraName: 'front',
      message: '',
      nozokiComments: [],
      keyboardHeight: 0,
      tmpPeerVideoNozokiHeight: 0,
      queue: null
    }
  },
  computed: {
    ...mapGetters('NotificationSetting', [
      'app_notice_sound',
      'app_notice_vib',
      'msg_notice_from_fuzai'
    ]),

    isMan(): boolean {
      return this.$store.getters['MyData/isMan']
    },

    isWoman(): boolean {
      return this.$store.getters['MyData/isWoman']
    },

    isShowPeerVideo(): boolean {
      return this.isVideoCall && this.isTalking && !this.isEndCalling
    },

    isShowPeerVideoNozoki(): boolean {
      return this.isMakeCallNozoki && this.isTalking && !this.isEndCalling
    },

    isShowMyVideo(): boolean {
      return (this.isVoiceCall || this.isVideoCall) && !this.isEndCalling
    },

    isShowMyVideoNozoki(): boolean {
      return this.isIncomingCallNozoki && !this.isEndCalling
    },

    isShowCallVoice(): boolean {
      return this.isBeforeCall || (this.isVoiceCall && this.isTalking)
    },

    isShowAnimation(): boolean {
      return !this.isTalking
    },

    isVoiceCall(): boolean {
      return this.$route.params.type === 'voice'
    },

    isVideoCall(): boolean {
      return this.$route.params.type === 'video'
    },

    isNozokiCall(): boolean {
      return this.$route.params.type === 'nozoki'
    },

    /**
     * のぞき通話の発信側判定
     */
    isMakeCallNozoki(): boolean {
      return this.isNozokiCall && this.$route.params.makecall === '1'
    },

    /**
     * のぞき通話の着信側判定
     */
    isIncomingCallNozoki(): boolean {
      return this.isNozokiCall && !this.$route.params.makecall
    },

    isMakeCalling(): boolean {
      return this.$route.params.makecall && !this.isTalking
    },

    isIncomingCalling(): boolean {
      return !this.$route.params.makecall && !this.isTalking
    },

    isBeforeCall(): boolean {
      return !this.isTalking && !this.isEndCalling
    },

    callMenuStyle(): string {
      return this.isTalking && (this.isVideoCall || this.isNozokiCall)
        ? 'background-color: transparent'
        : ''
    },

    callTypeLabel(): string {
      if (this.isVoiceCall) {
        return '音声通話'
      } else if (this.isVideoCall) {
        return 'ビデオ通話'
      } else if (this.isNozokiCall) {
        return 'のぞきライブ通話'
      }
      return ''
    },

    /**
     * ビデオ通話の subscriber の高さ
     */
    videoCallSubscriberHeight(): number {
      return Math.floor(window.innerHeight - 16 * 6.5)
    },

    /**
     * 一部の Android で keyboard が表示されると隠れてしまうので keyboard の高さだけずらす
     */
    chatFormStyle(): any {
      return this.$_platformIsAndroid
        ? {
            'padding-bottom': this.keyboardHeight + 'px'
          }
        : {}
    },

    callTime(): string {
      return `${this.minutes}:${this.seconds}`
    }
  },
  created() {
    if (!this.$_hasCordova) return

    // vuex の localStorage にするとエラーなどで値をクリアできないと再ログイン or 再インストールするまで着信できなくなる
    sessionStorage.setItem('isCalling', '1')

    window.StatusBar.hide()
    window.plugins.insomnia.keepAwake(
      () => {
        console.log('[keepAwake] Success')
      },
      err => {
        console.log('[keepAwake] Error', err.message)
      }
    )

    Keyboard.hideFormAccessoryBar(true)
    window.addEventListener('keyboardWillShow', this.handleKeyboardShow, false)
    window.addEventListener('keyboardWillHide', this.handleKeyboardHide, false)

    if (this.$_platformIsIOS) {
      // window.WkWebView.allowsBackForwardNavigationGestures(false)
    }

    this.canPhoneCallMSec = Number(this.$route.params.can_phone_call_time)
    this.queue = new Queue()

    this.$root.$on('resume', this.handleResume)
    this.$root.$on('endCallFromSystem', this.handleEndCallFromSystem)
    this.$root.$on('cordovaCallAnswer', this.handleCordovaCallAnswer)
    this.$root.$on('cordovaCallReject', this.handleCordovaCallReject)
    this.$root.$on('cordovaCallHangup', this.handleCordovaCallHangup)

    this.transparentWebView()
    this.$_disableBackbutton()
  },
  async mounted() {
    await this.$nextTick()

    if (!this.$_hasCordova) return

    // OpenTok の初期化処理は #peer-video, #my-video が描画済みである必要があるので
    // mounted で呼び出す
    if (this.$route.params.makecall) {
      // 発信開始
      if (isNaN(this.canPhoneCallMSec)) {
        // 発信側なのに通話可能時間を持っていなければ通話終了
        this.$_alert('発信失敗')
        this.$router.replace(`/user/${this.$route.params.user_id}`)
        return
      }
      this.initOpenTok()
      this.forceStopCall(CallEndReason.NotMakeCall)
    } else {
      // 着信開始
      // NOTE: iOS の着信側で、ココで Publisher の初期化を行うと発信側に着信側の映像が映らないことが頻繁に発生する
      this.forceStopCall(CallEndReason.NotAnswer)
      if (this.app_notice_vib === 1) {
        this.playVibration()
      }
    }
    if (this.app_notice_sound === 1) {
      this.playAudio()
    }
  },
  destroyed() {
    if (!this.$_hasCordova) return

    // 万が一まだ通話が切れていなかったときの対策
    if (this.isTalking) {
      this.endCall(CallEndReason.Abnormal)
    }

    sessionStorage.removeItem('isCalling')

    Keyboard.hideFormAccessoryBar(false)

    window.plugins.insomnia.allowSleepAgain(
      () => {
        console.log('[allowSleepAgain] Success')
      },
      err => {
        console.log('[allowSleepAgain] Error', err.message)
      }
    )

    window.removeEventListener('keyboardWillShow', this.handleKeyboardShow, false)
    window.removeEventListener('keyboardWillHide', this.handleKeyboardHide, false)

    // stopAudio() で戻してしまうと音声通話のときにイヤースピーカーから音が流れなくなる
    let speakerMode = window.AudioToggle.NORMAL
    if (this.$_platformIsIOS) {
      speakerMode = window.AudioToggle.SPEAKER
    }
    window.AudioToggle.setAudioMode(speakerMode)
    window.StatusBar.show()
    this.$_enableBackbutton()

    this.stopAudio()
    this.stopVibrate()

    // Publisher View が削除されないことがある対策
    if (this.publisher) {
      this.publisher.destroy()
    }
    if (this.session) {
      this.session.off('streamCreated', this.handleStreamCreated)
      this.session.off('streamDestroyed', this.handleStreamDestroyed)
      this.session.off('sessionConnected', this.handleSessionConnected)
      this.session.off('sessionDisconnected', this.handleSessionDisconnected)
      this.session.off('connectionDestroyed', this.handleConnectionDestroyed)
      this.session.off('signal:chat', this.handleSignalChat)
    }
    this.session = null
    this.publisher = null
    this.subscriber = null

    clearTimeout(this.forceStopTimer)
    clearTimeout(this.loadingTimer)
    clearTimeout(this.callAnswerWaitTimer)
    clearTimeout(this.countupCallTimer)
    clearTimeout(this.vibrationTimer)
    clearTimeout(this.endCallIntervalTimer)

    this.$root.$off('resume', this.handleResume)
    this.$root.$off('endCallFromSystem', this.handleEndCallFromSystem)
    this.$root.$off('cordovaCallAnswer', this.handleCordovaCallAnswer)
    this.$root.$off('cordovaCallReject', this.handleCordovaCallReject)
    this.$root.$off('cordovaCallHangup', this.handleCordovaCallHangup)

    this.clearTransparentWebView()

    if (this.$_platformIsIOS) {
      // window.WkWebView.allowsBackForwardNavigationGestures(true)
    }
  },
  methods: {
    /**
     * Publisher の初期化
     */
    initOpenTokPublisher() {
      console.log('[initOpenTokPublisher]')

      const publisherProperties = {
        audioBitrate: 50000,
        frameRate: 15,
        resolution: '640x480',
        height: 80,
        width: 80,
        publishAudio: true,
        publishVideo: false
      }
      let myVideoId = this.isIncomingCallNozoki ? 'my-video-nozoki' : 'my-video'
      if (this.isVoiceCall || this.isNozokiCall) {
        if (this.isMakeCallNozoki) {
          publisherProperties.publishAudio = false
        }
        // 音声通話かのぞき通話の発信側なら publisher を非表示にする
        publisherProperties.height = 1
        publisherProperties.width = 1
        // のぞきライブ通話の着信側は音を配信するので
        if (!this.isIncomingCallNozoki) {
          publisherProperties['videoSource'] = false
        }
        $('#' + myVideoId).setAttribute('style', 'top: 0; left: 0; width: 1px; height: 1px')
      } else if (this.isVideoCall && this.$_platformIsAndroid && this.isWoman) {
        // Android ビデオ通話 は映像が隠れてしまうので女性だけ上下分割して表示
        publisherProperties.height = this.videoCallSubscriberHeight / 2
        publisherProperties.width = window.innerWidth
        $('#' + myVideoId).setAttribute('style', 'top: 0; left: 0;')
      }
      // initPublisher に指定した要素の描画が完全に完了していないと表示順がおかしくなるので mounted() で呼び出される必要がある
      this.publisher = OT.initPublisher(myVideoId, publisherProperties)
    },

    /**
     * OpenTok の初期化
     */
    async initOpenTok() {
      console.log('[initOpenTok]')

      this.session = OT.initSession(
        this.$route.params.api_key,
        this.$route.params.session_id,
        this.$route.params.type
      )
      this.session.connect(this.$route.params.token, error => {
        if (error) {
          console.log(`There was an error connecting to the session: ${error}`)
        }
      })
      this.session.on('streamCreated', this.handleStreamCreated)
      this.session.on('streamDestroyed', this.handleStreamDestroyed)
      this.session.on('sessionConnected', this.handleSessionConnected)
      this.session.on('sessionDisconnected', this.handleSessionDisconnected)
      this.session.on('connectionDestroyed', this.handleConnectionDestroyed)
      this.session.on('signal:chat', this.handleSignalChat)
    },

    /**
     * 一定時間経過しても通話が開始されていなければ通話を終了
     */
    forceStopCall(reason: CallEndReason) {
      if (this.forceStopTimer) {
        return
      }
      this.forceStopTimer = setTimeout(() => {
        if (this.isTalking) {
          return
        }
        clearTimeout(this.forceStopTimer)
        this.endCall(reason)
      }, CALL_WAIT_TIME)
    },

    /**
     * 残り時間を toast で一度だけ表示
     */
    setToast(canTalkSeconds: number) {
      if (this.calledSnackBaers[canTalkSeconds]) return
      this.calledSnackBaers[canTalkSeconds] = true

      this.$toast.open({
        message: `残り通話時間${canTalkSeconds}秒`,
        type: 'is-success',
        position: 'is-bottom',
        queue: false
      })
    },

    /**
     * 発信 or 着信音の再生
     */
    async playAudio() {
      // 2重再生防止
      if (this.isPlayingAudio) {
        console.log('[playAudio] Media object already exists.')
        return
      }
      this.isPlayingAudio = true

      // Android で着信側ならデフォルトの着信音を鳴らす
      if (this.$_platformIsAndroid && !this.$route.params.makecall) {
        window.AudioToggle.setAudioMode(window.AudioToggle.RINGTONE)
        cordova.plugins.RingtonePlayer.play()
        console.log('[playAudio] RingtonePlayer')
      } else {
        let src = 'audio/'
        // ios 着信時には callkit の着信音が流れるので不要
        src += this.$route.params.makecall ? 'Telephone-Signal_Tone01-1.mp3' : ''
        this.media = this.getAudio(src)
        this.media.play({
          numberOfLoops: 'infinite', // 無限ループ
          playAudioWhenScreenIsLocked: false // サイレントモードなら鳴らさない
        })
        console.log('[playAudio] media')
        if (this.isVoiceCall) {
          // 800ms ぐらい sleep させないと iOS はスピーカーが切り替わらない
          await sleep(800)
          window.AudioToggle.setAudioMode(window.AudioToggle.EARPIECE)
        }
      }
    },

    /**
     * オーディオの再生を停止
     */
    stopAudio() {
      if (this.media) {
        this.media.stop()
        this.media.release()
        this.media = null
        console.log('[stopAudio] media.stop()')
      }
      if (this.$_platformIsAndroid && !this.$route.params.makecall) {
        cordova.plugins.RingtonePlayer.stop()
        console.log('[stopAudio] RingtonePlayer.stop()')
      }
      this.isPlayingAudio = false
    },

    /**
     * バイブレーションの再生
     */
    playVibration() {
      this.vibrationTimer = setTimeout(() => {
        window.navigator.vibrate(500)
        if (this.vibrationTimer) {
          this.playVibration()
        }
      }, 2000)
    },

    /**
     * バイブの停止
     */
    stopVibrate() {
      if (this.vibrationTimer) {
        clearTimeout(this.vibrationTimer)
        this.vibrationTimer = null
        window.navigator.vibrate(0)
      }
      console.log('[stopVibrate]')
    },

    /**
     * パスを取得する
     */
    getPath(): string {
      // location.href ですると # を含むためパスがおかしくなる
      const str = location.protocol + '//' + location.host + location.pathname + location.search
      const index = str.lastIndexOf('/')
      return str.substring(0, index + 1)
    },

    /**
     * Audio を取得する
     */
    getAudio(src: string): Media {
      if (this.$_platformIsAndroid) {
        src = this.getPath() + src
      }
      console.log('[getAudio] src', src)
      return new Media(
        src,
        () => {
          console.log('[getAudio] Success: Media')
        },
        err => {
          console.log('[getAudio] Error CODE:', err.code)
          this.isPlayingAudio = false
        },
        status => {
          if (!this.media) {
            console.log('[getAudio] media is null.')
            return
          }
          // Android でループさせる
          if (this.$_platformIsAndroid && status === Media.MEDIA_STOPPED && !this.isTalking) {
            console.log('[getAudio] loop')
            this.media.seekTo(0)
            this.media.play()
          }
        }
      )
    },

    /**
     * WebView を透過させる
     */
    transparentWebView() {
      console.log('[transparentWebView]')
      $('html').classList.add('is-transparent')
      $('body').classList.add('is-transparent')
      OT.updateViews()
    },

    /**
     * WebView 透過を解除
     */
    clearTransparentWebView() {
      console.log('[clearTransparentWebView]')
      $('html').classList.remove('is-transparent')
      $('body').classList.remove('is-transparent')
      OT.updateViews()
    },

    /**
     * カメラを切り替え
     */
    async switchCamera() {
      if (!this.publisher || this.disabledCameraButton) {
        return
      }
      this.disabledCameraButton = true
      this.cameraName = this.cameraName === 'front' ? 'back' : 'front'
      this.publisher.setCameraPosition(this.cameraName)

      // 短時間で何度も切り替えるとアプリが落ちる恐れあり
      await sleep(1000)
      this.disabledCameraButton = false
    },

    /**
     * OpenTok の後処理をしてからプロフィールに遷移
     */
    async endCall(reason: number) {
      if (this.isEndCalling) {
        return
      }
      this.isEndCalling = true

      console.log('[endCall]', reason)

      // NOTE: WKWebView でアプリ起動中のロック状態だとネット通信や非同期処理ができない
      const isNotActiveIOS = this.$_platformIsIOS && !sessionStorage.getItem('isActiveApp')

      if (!isNotActiveIOS) {
        // 直ぐに通話を切ろうとすると publisher が削除できない
        await sleep(1000)
      }

      this.stopAudio()
      this.stopVibrate()
      await Call.endCall({
        log_no: this.$route.params.log_no,
        reason: reason
      })

      if (this.session) {
        // NOTE: unpublish すると android で例外が発生しアプリが強制終了する
        this.session.disconnect()
      }

      // ios で着信時のみ CordovaCall を使用している
      if (this.$_platformIsIOS && !this.$route.params.makecall) {
        cordova.plugins.CordovaCall.endCall(
          () => {
            console.log('[CordovaCall endCall] Success')
          },
          err => {
            console.error('[CordovaCall endCall] Error', err)
          }
        )
      }

      this.isTalking = false

      if (this.routerBackTimer) {
        return
      }

      // $route.params は文字列しか扱えない
      const shouldMoveToBackground =
        this.$_platformIsAndroid &&
        !this.$route.params.makecall &&
        this.$route.params.foreground === 'false'

      // 直ぐに遷移すると publisher や subscriber view が残ったままの状態がしばらく続く
      this.routerBackTimer = setTimeout(async () => {
        clearTimeout(this.routerBackTimer)
        this.routerBackTimer = null

        // 着信時 && バックグラウンド && Android ならタスク一覧に残さず裏側に
        if (shouldMoveToBackground) {
          cordova.plugins.backgroundMode.excludeFromTaskList()
          cordova.plugins.backgroundMode.moveToBackground()
          if (this.msg_notice_from_fuzai === 1) {
            this.$_showLocalNotification({
              text: `${this.$route.params.name}さんから着信がありました`,
              id: this.$route.params.user_id
            })
          }
        }

        if (this.isMan && this.isTimeOver) {
          // 男性でポイント切れなら
          const message = 'ポイントがなくなりました。\nチャージして再度お掛け直しください。'
          await this.$_showPointBuyDialog(message, '')
        }

        this.$router.back()
      }, 1000)
    },

    /**
     * アプリがアクティブになると呼び出される
     */
    handleResume() {
      if (this.queue.size > 0) {
        this.queue.start()
      }
    },

    /**
     * 別のクライアントによって新しい Stream が生成されると呼び出される
     */
    async handleStreamCreated(event) {
      console.log('[onStreamCreated]', event)
      if (this.$route.params.makecall) {
        this.isLoading = true
      }

      this.stopAudio()
      this.stopVibrate()

      // すこし sleep させないとスピーカーから音が流れないことがある?
      await sleep(100)

      // subscriber のデータストリーミング開始
      const subscriberProperties = {
        // Android 8.0 Xperia では innerHeight にしないと高さが合わない
        height: this.videoCallSubscriberHeight,
        width: window.screen.width,
        subscribeToAudio: true,
        subscribeToVideo: false
      }

      let peerVideoId = 'peer-video'
      if (this.isMakeCallNozoki) {
        subscriberProperties.height = window.innerHeight - 16 * 20
        peerVideoId = 'peer-video-nozoki'
      }

      if (this.isVoiceCall || this.isIncomingCallNozoki) {
        // 音声通話 or のぞき通話の着信側なら相手の映像を非表示にする
        subscriberProperties.height = 1
        subscriberProperties.width = 1
        $('#' + peerVideoId).setAttribute('style', 'top: 0; left: 0; width: 1px; height: 1px')
      } else if (this.isVideoCall && this.$_platformIsAndroid && this.isWoman) {
        // Android ビデオ通話 は映像が隠れてしまうので女性だけ上下分割して表示
        subscriberProperties.height /= 2
        $('#' + peerVideoId).setAttribute(
          'style',
          `top: ${encodeURIComponent(subscriberProperties.height + '')}px; left: 0;`
        )
      }
      this.subscriber = this.session.subscribe(
        event.stream,
        peerVideoId,
        subscriberProperties,
        this.handleStartedCall
      )
    },

    /**
     * Stream が破棄されたときに呼び出される
     */
    handleStreamDestroyed(event) {
      console.log('[handleStreamDestroyed]', event)
      if (this.streamDestroyedTimer) {
        return
      }
      this.disabledEndCallButton = true

      // 通話が相手に切られたら切断処理
      // 直に終了通知を送信するとサーバで2重に処理される可能性があるのでディレイをかける
      this.streamDestroyedTimer = setTimeout(() => {
        clearTimeout(this.streamDestroyedTimer)
        this.streamDestroyedTimer = null
        this.endCall(CallEndReason.Normal)
        OT.updateViews()
      }, 2000)
    },

    /**
     * Session が接続されると呼び出される
     */
    async handleSessionConnected(event) {
      console.log('[handleSessionConnected]', event)
      this.isConnectedOpenTokSession = true

      if (!this.publisher) {
        this.initOpenTokPublisher()
      }
      this.session.publish(this.publisher)
    },

    /**
     * session が切断されたときに呼び出される
     */
    handleSessionDisconnected(event) {
      console.log('[handleSessionDisconnected]', event)
    },

    handleConnectionDestroyed(event) {
      console.log('[handleConnectionDestroyed]', event)
    },

    /**
     * 通話開始通知の送信に成功したら呼ばれる
     */
    async handleStartedCall() {
      console.log('[handleStartedCall]')

      this.isTalking = true
      this.loadingTimer = setTimeout(() => {
        this.isLoading = false
        clearTimeout(this.loadingTimer)
        this.loadingTimer = null
      }, 2000)

      if (this.isVideoCall) {
        // ビデオ通話ならお互い表示
        this.publisher.publishVideo(true)
        this.subscriber.subscribeToVideo(true)
      } else if (this.isNozokiCall) {
        if (this.$route.params.makecall) {
          // のぞき通話の発信側なら相手の映像だけ
          this.subscriber.subscribeToVideo(true)
        } else {
          // のぞき通話の着信側なら自分の映像だけ
          this.publisher.publishVideo(true)

          // #my-video-nozoki のサイズが合っておらずなぜがか隙間ができるので再設定
          let myVideoNozoki: HTMLElement = $('#my-video-nozoki')
          myVideoNozoki.style.height = `${window.innerHeight - 16 * 20}px`
          myVideoNozoki.style.width = `${window.screen.width}px`
          myVideoNozoki = null
          OT.updateViews()
        }
      }

      // 通話開始をサーバに通知
      try {
        await Call.report({
          log_no: this.$route.params.log_no
        })

        if (this.isMakeCallNozoki) {
          // のぞき通話時の Subscriber の高さをキャッシュする
          this.tmpPeerVideoNozokiHeight = $('#peer-video-nozoki').clientHeight
        }
      } catch (err) {
        this.endCall(CallEndReason.NetworkError)
        return
      }

      // 通話時間を更新
      this.startTime = Date.now()
      this.countupCallTime()
    },

    /**
     * 通話時間をカウント
     */
    countupCallTime() {
      this.countupCallTimer = setTimeout(() => {
        // 経過時間
        const now = Date.now()
        this.elapsedTime = now - this.startTime
        const m = Math.floor(this.elapsedTime / 60000)
        const s = Math.floor((this.elapsedTime % 60000) / 1000)

        // 通話時間の描画
        this.minutes = (m + '').padStart(2, '0')
        this.seconds = (s + '').padStart(2, '0')

        if (this.$route.params.makecall) {
          // 発信側なら通話中通知を定期的にサーバに POST
          const elapsedSeconds = Math.floor(((now - this.lastTalkingReportTime) % 60000) / 1000)
          if (elapsedSeconds >= TALKING_REPORT_SEC) {
            Call.notifyTakingReport({
              log_no: this.$route.params.log_no
            })
            this.lastTalkingReportTime = now
          }
        }

        // 男女ともに残り通話時間をトーストで通知
        const diff = (this.canPhoneCallMSec - this.elapsedTime) / 1000
        if (this.$route.params.makecall && diff <= 0) {
          // 発信側ならまだ通話可能なのかチェック
          this.isTimeOver = true
          this.endCall(CallEndReason.TimeOver)
        } else if (!this.calledSnackBaers[10] && 0 <= diff && diff <= 10) {
          this.setToast(10)
        } else if (!this.calledSnackBaers[30] && 10 < diff && diff <= 30) {
          this.setToast(30)
        } else if (!this.calledSnackBaers[60] && 30 < diff && diff <= 60) {
          this.setToast(60)
        }

        if (this.isEndCalling || !this.isTalking || this.isTimeover) {
          clearTimeout(this.countupCallTimer)
        } else {
          this.countupCallTime()
        }
      }, 100)
    },

    /**
     * 着信側が応答ボタンタップ
     */
    async handleAnswerClick() {
      console.log('[handleAnswerClick]')
      const isBackgroundVoIP = this.$_platformIsIOS && !document.hasFocus()

      if (isBackgroundVoIP) {
        // iOS は VoIP Push で起動しバックグラウンドで HTTP リクエストを送信するとエラーになる
        // ここではキューに処理を追加して resume した時点で実行する
        this.queue.enqueue(this.answerCall.bind(this))
      } else {
        this.answerCall()
      }
    },

    /**
     * 通話終了ボタンタップ
     */
    async handleEndClick() {
      if (this.disabledEndCallButton) {
        return
      }

      console.log('[handleEndClick]')
      this.disabledEndCallButton = true

      const _endCall = () => {
        // 発信中に切断
        if (this.isMakeCalling) {
          this.endCall(CallEndReason.DisconnectMakeCalling)
          // 着信拒否
        } else if (this.isIncomingCalling) {
          this.endCall(CallEndReason.Reject)
          // 通話終了
        } else {
          this.endCall(CallEndReason.Normal)
        }
      }

      if (this.isMakeCalling) {
        // 発進直後に切断すると Session Connect が切断後に実行され発信画面のままになるので
        // 通話の切断は session が接続されるまで待つ
        const _endCallAsync = () => {
          this.endCallIntervalTimer = setTimeout(() => {
            if (!this.isConnectedOpenTokSession) {
              _endCallAsync()
              return
            }

            clearTimeout(this.endCallIntervalTimer)
            _endCall()
          }, 1000)
        }
        _endCallAsync()
      } else {
        _endCall()
      }
    },

    /**
     * のぞき通話終了ボタンタップ
     */
    async handleNozokiLiveEndClick() {
      const buttonLabels = ['キャンセル', '切断']
      const buttonIndex = await this.$_confirm('のぞきライブ通話を切断しますか？', '', buttonLabels)
      if (this.$_clickedConfirmOK(buttonIndex)) {
        this.handleEndClick()
      }
    },

    /**
     * 応答処理
     */
    async answerCall() {
      if (this.disabledAnswerButton) {
        return
      }
      this.disabledAnswerButton = true
      this.isLoading = true

      // すぐに応答すると着信側の映像が発信側に映らないことがある
      // またカメラ・マイク未許可時に応答してからすぐに post するとエラーになる
      await sleep(3000)

      try {
        // iOS ロック状態で着信を受けるとなぜか時間差で2回 handleAnswerClick() が呼ばれる
        // 複数回の answer を POST してもエラーにならないようサーバ側で対処
        const data = await Call.answer({
          log_no: this.$route.params.log_no
        })
        // 無効な着信に応答するとエラーになるのを防ぐ
        if (data.error) {
          console.error(data.error)
          this.endCall(CallEndReason.DisconnectMakeCalling)
          return
        }
        this.initOpenTok()

        // 発信側が発信中にタスクキルなどでアプリを強制終了した場合、着信側は応答したままになる対策
        // 応答してから一定時間たっても通話中にならんなければ通話終了
        this.callAnswerWaitTimer = setTimeout(() => {
          if (!this.isTalking) {
            this.handleEndClick()
          }
          clearTimeout(this.callAnswerWaitTimer)
          this.callAnswerWaitTimer = null
        }, CALL_ANSWER_WAIT_TIME)
      } catch (err) {
        console.error(err)
        this.endCall(CallEndReason.Abnormal)
      }
    },

    /**
     * CallKit の応答ボタンタップ時に呼び出される
     */
    handleCordovaCallAnswer() {
      console.log('[handleCordovaCallAnswer]')
      this.handleAnswerClick()
    },

    /**
     * CallKit の拒否ボタンタップ時に呼び出される
     */
    handleCordovaCallReject() {
      console.log('[handleCordovaCallReject]')
      this.handleEndClick()
    },

    /**
     * CallKit の通話中画面の終了ボタンクリックで呼び出される
     */
    handleCordovaCallHangup() {
      console.log('[handleCordovaCallHangup]')
      this.handleEndClick()
    },

    /**
     * システムから通話終了通知が届いた
     */
    handleEndCallFromSystem() {
      console.log('[handleEndCallFromSystem]')
      this.endCall(CallEndReason.System)
    },

    /**
     * のぞき見通話のコメント送信
     */
    async handleSubmit() {
      if (this.message.length === 0) return

      const chatData = {
        text: this.message
      }
      try {
        const data = await Call.chat({
          other_id: this.$route.params.user_id,
          log_no: this.$route.params.log_no,
          text: chatData.text
        })
        if (data.error) {
          console.error(data.error)
        }
        chatData.text = data.text
        this.session.signal(
          {
            data: JSON.stringify(chatData),
            type: 'chat'
          },
          err => {
            console.error(err)
          }
        )
        this.nozokiComments.unshift(chatData)
        $('.Call__nozoki-comment-list').scrollTop = 0
        if (this.$_platformIsAndroid) {
          $('.ChatForm').setAttribute('style', `padding-bottom: 0`)
        }
        // 明示的に空にしないと chat-form の value に残っている
        this.message = ''

        // 画面が狭くなるのでソフトウェアキーボードを閉じる
        $('.ChatForm__textarea').blur()
      } catch (err) {
        console.error(err)
      }
    },

    /**
     * チャットシグナルの受信
     */
    handleSignalChat(event) {
      if (this.session.connection.connectionId !== event.from.connectionId) {
        this.nozokiComments.unshift(JSON.parse(event.data))
      }
    },

    /**
     * キーボード表示
     */
    handleKeyboardShow(event) {
      this.keyboardHeight = event.keyboardHeight

      if (this.isMakeCallNozoki) {
        // キーボードが表示されても OpenTok の View が縮小されず
        // 送信ボタンなどがタップできなくなるので手動で縮小
        let peerVideoNozoki: HTMLElement = $('#peer-video-nozoki')
        peerVideoNozoki.style.height = `${this.tmpPeerVideoNozokiHeight - this.keyboardHeight}px`
        peerVideoNozoki = null
        OT.updateViews()
      }
    },

    /**
     * キーボード非表示
     */
    handleKeyboardHide() {
      this.keyboardHeight = 0

      if (this.isMakeCallNozoki) {
        // OpenTok の View をもとに戻す
        let peerVideoNozoki: HTMLElement = $('#peer-video-nozoki')
        peerVideoNozoki.style.height = `${this.tmpPeerVideoNozokiHeight}px`
        peerVideoNozoki = null
        OT.updateViews()
      }
    }
  }
})
